export default __webpack_public_path__ + "static/media/phone.e5f0a819.svg";